import { Box, Flex, Switch, Text, Checkbox, Divider, Image, Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import { DynamicTable, ColumnDefinition } from "@/components/DynamicTable";
import { useEffect, useState } from "react";
import { Input, Select, DatePickerInput } from "@/components";
import { RadioGroupBody } from "../RadioGroupBody";
import { MethodProps } from "@/models";
import { useAdvanceReceipt } from "../useAdvanceReceipt";
import { installments as installmentsSelect, installments21x } from "@/utils";
import { usePreviewContext } from "@/contexts/PreviewContext";
import { Tooltip } from "@/components/Tooltip";
import { valueDiscontCredicard } from "@/utils/calcDescontCreditCard";


interface PaymentMethod {
  discount: any
}

interface CustomInstallmentValue {
  paymentMethod: "PIX" | "BANK_SLIP" | "CREDIT_CARD" | "CREDIT_CARD_EARLY_BUYER" | "CREDIT_CARD_EARLY_SELLER";
  installments: number;
}

export type ListOfCustomInstallmentValue = Array<CustomInstallmentValue>;

export function Method({
  setValue,
  creditCardType,
  register,
  control,
  initialData,
  title,
  id,
  reg,
  watch,
  anchoringState,
  paymentLinkType,
  setCreditCardType,
  setAnchoringState,
  dateSwitchState,
  setDateSwitchState,
  isPunctualCharge,
  setPaymentsMethodsActive,
  split,
  hasInstallmentMix,
  disableDiscount,
  disableCardTypeSelection
}: MethodProps) {
  const methodInitialState: PaymentMethod = watch(reg);
  const { previewData, setPreviewData } = usePreviewContext();
  const name = `${reg}Percent`;
  const [methodState, setMethodState] = useState(!!methodInitialState);
  const [creditCardReceivement, setCreditCardReceivement] = useState<
    "RECURRENT" | "EARLY"
  >(creditCardType === "RECURRENT" ? "RECURRENT" : "EARLY");

  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const [creditCardTax, setCreditCardTax] = useState<"EARLY_BUYER" | "EARLY_SELLER">(
    creditCardType === "EARLY_BUYER" || creditCardType === "EARLY_SELLER" ? creditCardType : "EARLY_BUYER");

  const verifyCreditCardCustomInstallment = () => watch("customInstallmentsValuesCreditCard") ? "customInstallmentsValuesCreditCard" : "installments";

  const { installmentArray } = useAdvanceReceipt(anchoringState, watch, `enableCreditCardPercent`, paymentLinkType, verifyCreditCardCustomInstallment());
  const featureTogglesUser = localStorage?.getItem("barte-features-list-user");


  function handleMethodState() {
    const newState = !methodState;
    
    setValue(reg, newState);
    setMethodState(newState);
    setPreviewData((prevPreviewData) => ({
      ...prevPreviewData,
      [reg]: newState,
    }));

    // Se o método está sendo desativado, zerar o desconto
    if (!newState) {
      setValue(name, null);
      setPreviewData((prevPreviewData) => ({
        ...prevPreviewData,
        [name]: null,
      }));
    }
  }

  useEffect(() => {
    if (creditCardReceivement === "EARLY") {
      setCreditCardType(creditCardTax);
    } else {
      setCreditCardType(creditCardReceivement);
    }

  }, [creditCardTax, creditCardReceivement]);

  useEffect(() => {
    if (
      (creditCardType === "EARLY_SELLER" || creditCardType === "EARLY_BUYER") &&
      creditCardType !== creditCardTax
    ) {
      setCreditCardTax(creditCardType);
    }
  }, [creditCardType]);

  useEffect(() => {
    setMethodState(!!methodInitialState);
  }, [watch(reg)]);
  function formatIdName(id: string) {
    let idNames = {
      "creditCard": "Cartão",
      "creditCardWithoutAntecipation": "Cartão",
      "bankSlip": "Boleto",
      "pix": "Pix"
    }
    return idNames[id];
  }
  function formatRegisterIdName(id: string): string {
    let idNames = {
      "creditCard": "customInstallmentsValuesCreditCard",
      "creditCardWithoutAntecipation": "customInstallmentsValuesCreditCard",
      "bankSlip": "customInstallmentsValuesBankSlip",
      "pix": "customInstallmentsValuesPix"
    }
    return idNames[id];
  }
  useEffect(() => {
    setPaymentsMethodsActive((prevState) => ({
      ...prevState,
      [reg]: methodInitialState
    }))

  }, [methodInitialState])

  return (
    <Flex
      border="1px solid #E6E9F0"
      borderRadius="8px"
      backgroundColor="white"
      p="16px 16px 16px 16px"
      flexDir="column"
      gap="1.5rem"

    >

      <Flex align="center"
        justify="space-between"
        flexDirection="column"
      >

        <Flex
          align="center"
          justify="space-between"
          gap="11px"
          w="100%"

        >
          <Flex gap="8px">
            {title === "Cartão de Crédito" ? <Image w="24px" h="24px" src={"/images/icons/ActiveCreditCard.svg"} />
              : title === "Boleto" ? <Image w="24px" h="24px" src={"/images/icons/ActiveBoleto.svg"} /> :
                <Image w="24px" h="24px" src={"/images/icons/ActivePix.svg"} />}
            <Text fontSize="1rem" color="black" fontWeight="600">
              {title}
            </Text>
          </Flex>

          <Flex

          >

            <Flex
              gap="8px"
              alignItems="flex-end"
            >
              {id === "creditCardWithoutAntecipation" && (
                <Box
                  bgColor="rgba(27, 214, 168, 0.3)"
                  color="#20473D"
                  fontSize="12px"
                  lineHeight="14.52px"
                  p="4px 8px"
                  borderRadius="4px"
                >
                  35% menos inadimplência
                </Box>
              )}

              <Switch
                name={reg}
                colorScheme="cyan"
                {...register(reg)}
                size="sm"
                isChecked={methodState}
                defaultChecked={methodState}
                onChange={handleMethodState}
                disabled={(id === "bankSlip" && split) || (id === "pix" && split)}
              />
            </Flex>
            {(id === "bankSlip" && split) && (
              <Tooltip label="Método de boleto bloqueado por causa que o split está ativado."/>

            )}
            {(id === "pix" && split) && (
              <Tooltip label="Método de pix bloqueado por causa que o split está ativado."/>

          )}

          </Flex>

        </Flex>
        {methodState && (
          <Divider />
        )}
      </Flex>
      {methodState && (
        <Flex flexDir="column" gap="1.5rem"
          w="100%"


        >

          {methodInitialState?.discount && (
            <Input
              maxLength={3}
              mask="percentage"
              type="text"
              name={name}
              setValue={setValue}
              switchActive={methodInitialState?.discount ?? false}
              hasSwitch
              switchDisabled={disableDiscount}
              placeholder="0%"
              label={`Desconto no ${title}`}
              register={{ ...register(name) }}
            />
          )}
          {!methodInitialState?.discount && (
            <Input
              maxLength={3}
              mask="percentage"
              type="text"
              name={name}
              setValue={setValue}
              switchActive={methodInitialState?.discount ?? false}
              hasSwitch
              switchDisabled={disableDiscount}
              placeholder="0%"
              maxW="332px"
              label={`Desconto no ${title}`}
              register={{ ...register(name) }}

            />

          )}

          {(isPunctualCharge && id === "creditCard") && (
            <>
              <DatePickerInput
                tooltipText="Data de vencimento da primeira cobrança.
                  A data dos próximos vencimentos, se houver,
                  será no mesmo dia do mês."
                startEnabled={initialData?.scheduledDate}
                disabledState={dateSwitchState}
                setDisabledState={setDateSwitchState}
                label="Agendar primeira cobrança no cartão para:"
                hasSwitch

                isCustomizableDate
                selectedDate={new Date()}
                control={control}
                name="date"
                register={{ ...register("date") }}
                rules={{ required: "Preenchimento obrigatório!" }}
              />
              <Select
                hasInstallmentMix={hasInstallmentMix}
                label={hasInstallmentMix ? "Assumir as taxas de parcelamento" : `Parcelamento Máximo no ${formatIdName(id)} `}
                name={`${formatRegisterIdName(id)}`}
                defaultValue={initialData ? initialData?.paymentOrder?.customInstallmentsValues[0]?.installments : user.idSeller === 4483 ? 6 : 10}
                optionsList={featureTogglesUser?.includes("view_seller_full_installments") ? installmentsSelect.map((item, index) => ({ id: index, title: item.title, value: item.value })) : installments21x.map((item, index) => ({ id: index, title: item.title, value: item.value }))}
                // hasSwitch
                maxW="332px"
                setValue={setValue}
                register={{ ...register(formatRegisterIdName(id)) }}
              />
            </>

          )}
          {(isPunctualCharge && id === "bankSlip") && (
            <Select
              label={`Parcelamento Máximo no ${formatIdName(id)} `}
              name={`${formatRegisterIdName(id)}`}
              defaultValue={initialData?.paymentOrder?.customInstallmentsValues[1]?.installments}
              optionsList={Array.from({ length: 21 }, (_, i) => ({ id: `${i + 1}`, title: `${i + 1}x`, value: i + 1 }))}
              // hasSwitch
              setValue={setValue}
              register={{ ...register(formatRegisterIdName(id)) }}
            />
          )}
          {(isPunctualCharge && id === "pix") && (
            <Select
              label={`Parcelamento Máximo no ${formatIdName(id)} `}
              name={`${formatRegisterIdName(id)}`}
              defaultValue={initialData?.paymentOrder?.customInstallmentsValues[2]?.installments}
              optionsList={Array.from({ length: 12 }, (_, i) => ({ id: `${i + 1}`, title: `${i + 1}x`, value: i + 1 }))}
              // hasSwitch
              setValue={setValue}
              register={{ ...register(formatRegisterIdName(id)) }}
            />
          )}

          {
            previewData?.enablePix && id === "pix" && (
              <>
                <Divider />

                {(() => {
                  const tableData = [{
                    clientePaga: previewData?.pix?.installments >= 2 
                      ? `1x a ${previewData?.pix?.installments}x`
                      : "1x",
                    total: valueDiscontCredicard(previewData, previewData?.pix?.discount),
                    voceRecebe: "De forma recorrente de acordo com parcelamento"
                  }];

                  const columns: ColumnDefinition<any>[] = [
                    {
                      key: "clientePaga",
                      title: "Cliente paga",
                      dataIndex: "clientePaga",
                      align: "left",
                      render: (clientePaga: string) => (
                        <Text fontSize="14px" fontWeight="400" color="rgba(110, 122, 145, 1)">
                          {clientePaga}
                        </Text>
                      ),
                    },
                    {
                      key: "total",
                      title: "Total",
                      dataIndex: "total",
                      align: "left",
                      render: (total: string) => (
                        <Text fontSize="12px" textAlign="left" maxW="100px">
                          {total}
                        </Text>
                      ),
                    },
                    {
                      key: "voceRecebe",
                      title: "Você recebe",
                      dataIndex: "voceRecebe",
                      align: "left",
                      render: (voceRecebe: string) => (
                        <Flex flexDirection="column" gap="4px">
                          <Text fontSize="12px" color="black" w="150px" fontWeight="500">
                            {voceRecebe}
                          </Text>
                        </Flex>
                      ),
                    },
                  ];

                  return (
                    <DynamicTable
                      data={tableData}
                      columns={columns}
                      rowKey={() => "pix-row"}
                      locale={{ emptyText: "Sem dados" }}
                    />
                  );
                })()}
     
              </>

            )}


          {
            previewData?.enableBankSlip && id === "bankSlip" && (
              <>
                <Divider />
                {(() => {
                  const tableData = [{
                    clientePaga: previewData?.boleto?.installments >= 2 
                      ? `1x a ${previewData?.boleto?.installments}x`
                      : "1x",
                    total: valueDiscontCredicard(previewData, previewData?.boleto?.discount),
                    voceRecebe: "De forma recorrente de acordo com parcelamento"
                  }];

                  const columns: ColumnDefinition<any>[] = [
                    {
                      key: "clientePaga",
                      title: "Cliente paga",
                      dataIndex: "clientePaga",
                      align: "left",
                      render: (clientePaga: string) => (
                        <Text fontSize="12px" fontWeight="400">
                          {clientePaga}
                        </Text>
                      ),
                    },
                    {
                      key: "total",
                      title: "Total",
                      dataIndex: "total",
                      align: "left",
                      render: (total: string) => (
                        <Text fontSize="12px" textAlign="left" maxW="100px">
                          {total}
                        </Text>
                      ),
                    },
                    {
                      key: "voceRecebe",
                      title: "Você recebe",
                      dataIndex: "voceRecebe",
                      align: "left",
                      render: (voceRecebe: string) => (
                        <Flex flexDirection="column" gap="4px">
                          <Text fontSize="12px" color="black" w="150px" fontWeight="500">
                            {voceRecebe}
                          </Text>
                        </Flex>
                      ),
                    },
                  ];

                  return (
                    <DynamicTable
                      data={tableData}
                      columns={columns}
                      rowKey={() => "bankSlip-row"}
                      locale={{ emptyText: "Sem dados" }}
                    />
                  );
                })()}

              </>

            )}
          {id === "creditCard" && !hasInstallmentMix && (
            <Box
              pointerEvents={disableCardTypeSelection ? "none" : "auto"}
              opacity={disableCardTypeSelection ? 0.6 : 1}
              aria-disabled={disableCardTypeSelection}
            >
              <RadioGroupBody
                array={installmentArray}
                creditCardReceivement={creditCardReceivement}
                setCreditCardReceivement={setCreditCardReceivement}
                creditCardTax={creditCardTax}
                setCreditCardTax={setCreditCardTax}
                isPunctualCharge={isPunctualCharge}
                setAnchoringState={setAnchoringState}
                anchoringState={anchoringState}
                creditCardType={creditCardType}
                watch={watch}
                selectedInstallments={watch("customInstallmentsValuesCreditCard")}
              />
            </Box>
          )}
        </Flex>
      )}
    </Flex>
  );
}
